import { useState } from 'react';
import style from './accordion-item.module.scss'
import Link from 'next/link'
import { useRouter } from 'next/router';
import Image from 'next/image'
import { InView } from "react-intersection-observer"
import animations from '@styles/animations.module.scss'

interface AccordionItemProps {
    id: number;
    title: string;
    text: Array<string>;
}

const AccordionItem = ({ id, title, text }: AccordionItemProps) => {
    const router = useRouter();
    const [opened, setOpened] = useState(false);

    return (
        <>
            <hr />
            <div className={opened ? `${style.item__block} ${style.item__block_opened}` : style.item__block}>
                <Link href={router.asPath} scroll={false}>
                    <a onClick={() => setOpened(!opened)}>
                        <InView triggerOnce={true}>
                            {({ inView, ref, entry }: any) => {
                                if (inView) {
                                    entry?.target.classList.add(animations.active);
                                }
                                return (
                                    <div ref={ref} className={`${style.item} ${animations.scroll__animation}`}>
                                        <div className={`${style.number__block} ${style.item__number}`}>
                                            {id}
                                        </div>
                                        <div className={style.item__block__text}>
                                            <div className={`${style.item__title} ${style.title}`}>
                                                {title}
                                            </div>
                                            <div className={style.item__btn}>
                                                <Image sizes="100px" alt="accordion-icon" layout={'fill'} src='/wallex-images/ic-plus.svg' />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }}
                        </InView>
                    </a>
                </Link>
                <div className={style.item__text}>
                    {
                        text.map((item: string, index: number) => {
                            return (
                                <div key={index} className={style.text}>
                                    {item}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </>
    )
}

export default AccordionItem;
